import { NOTIFICATAIONS_API_URL } from "../../config";
import * as ActionCreators from "./creators";
import fetchRetry from "../fetch_retry";

export function fetchNotifications() {
  return function (dispatch, getState) {
    dispatch(ActionCreators.fetchingAppNotifications());

    let request_options = {
      headers: { "Content-Type": "application/json" },
    };
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }
    return fetchRetry(`${NOTIFICATAIONS_API_URL}/notifications?limit=50`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorFetchingAppNotifications(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorFetchingAppNotifications(response.message));
        } else {
          let notifications = response["results"];
          response["meta"] = response["meta"] || {};
          let last_evaluated_key = response["meta"]["last_evaluated_key"]
            ? response["meta"]["last_evaluated_key"]
            : null;
          dispatch(
            ActionCreators.fetchedAppNotifications(notifications, response["meta"]["has_more"], last_evaluated_key)
          );
        }
      });
  };
}

export function markAsRead(u_guid, c_at) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.deletingAppNotification());
    const payload = {
      u_guid: u_guid,
      c_at: c_at,
    };
    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "PATCH",
      body: JSON.stringify(payload),
    };

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(`${NOTIFICATAIONS_API_URL}/notifications/read`, request_options, dispatch, getState)
      .then(
        (response) => response.json(),
        (error) => {
          dispatch(ActionCreators.errorDeletingAppNotification(error));
        }
      )
      .then((response) => {
        if ("message" in response || "errors" in response) {
          dispatch(ActionCreators.errorDeletingAppNotification(response.message));
        } else {
          dispatch(ActionCreators.deletedAppNotification(u_guid, c_at));
          dispatch(fetchNotifications());
        }
      });
  };
}
